import ZonesPage from './components/ZonesPage';
import HistoryPage from './components/HistoryPage';
import { HIDE_SYSTEM_ROUTE } from '../../configs';

const routes = [
  {
    path: '/zones',
    name: 'menu.zones',
    icon: 'pin-map',
    loginRequired: true,
    component: ZonesPage,
    weight: 2,
    permission: [],
    children: [],
  },
  {
    path: '/zones/history',
    name: 'menu.zones.history',
    icon: 'pin-map',
    loginRequired: true,
    component: HistoryPage,
    weight: 2,
    permission: [],
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    children: [],
  },
];

export default routes;
